import { Language, TemplateSubType, TemplateType } from '../../../types/dto-app';

export const leaseRentIndexationSkippedTemplates = [
  {
    id: '-122001',
    language: Language.EN,
    subject: "Your lease won't be indexed this year",
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_RENT_INDEXATION_SKIPPED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Dear {{listAllTenants lease}},</p>
        <p></p>
        <p>I am pleased to inform you that no indexation will be applied this year on the lease located at <strong>{{getLeaseMainAddress lease}}</strong> and having taken effect on <strong>{{formatDate lease.startDate}}</strong>.</p>
        <p></p>
        {{#if (hasMultipleUnits lease)}}
        <p>List of involved rental units: {{unitAddressList units}}.</p>
        <p></p>
        {{/if}}
        {{#if (hasComment leasePriceHistory)}}
        <p>Comment:</p>
        <i>{{leasePriceHistory.comment}}</i>
        <p></p>
        {{/if}}
        <p>As a result, the monthly rent will remain unchanged at <strong>{{lease.totalRentalPrice}} €</strong> and the monthly charges at <strong>{{getLeaseCurrentMonthlyCharges lease}} €</strong>.</p>
        <p></p>
        <p>Kind regards,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
  {
    id: '-122002',
    language: Language.FR,
    subject: 'Votre bail ne sera pas indexé cette année',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_RENT_INDEXATION_SKIPPED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Cher/Chère {{listAllTenants lease}},</p>
        <p></p>
        <p>J'ai le plaisir de vous informer qu'aucune indexation ne sera appliquée cette année pour votre bail sis <strong>{{getLeaseMainAddress lease}}</strong> et ayant pris effet le <strong>{{formatDate lease.startDate}}</strong>.</p>
        <p></p>
        {{#if (hasMultipleUnits lease)}}
        <p>Liste des unités locatives concernées: {{unitAddressList units}}.</p>
        <p></p>
        {{/if}}
        {{#if (hasComment leasePriceHistory)}}
        <p>Commentaire:</p>
        <i>{{leasePriceHistory.comment}}</i>
        <p></p>
        {{/if}}
        <p>Il en résulte que le loyer mensuel demeurera inchangé à <strong>{{lease.totalRentalPrice}} €</strong> et les charges mensuelles à <strong>{{getLeaseCurrentMonthlyCharges lease}} €</strong>.</p>
        <p></p>
        <p>Bien à vous,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
  {
    id: '-122003',
    language: Language.NL,
    subject: 'Indexering huur',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_RENT_INDEXATION_SKIPPED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Geachte {{listAllTenants lease}},</p>
        <p></p>
        <p>Ik ben blij u te kunnen meedelen dat er dit jaar geen indexering zal worden toegepast op het huurcontract gelegen op <strong>{{getLeaseMainAddress lease}}</strong> ingegaan op <strong>{{formatDate lease.startDate}}</strong>.</p>
        <p></p>
        {{#if (hasMultipleUnits lease)}}
        <p>Lijst van betrokken huureenheden: {{unitAddressList units}}.</p>
        <p></p>
        {{/if}}
        {{#if (hasComment leasePriceHistory)}}
        <p>Opmerking:</p>
        <i>{{leasePriceHistory.comment}}</i>
        <p></p>
        {{/if}}
        <p>Bijgevolg zal de maandelijkse huurprijs ongewijzigd blijven op <strong>{{lease.totalRentalPrice}} €</strong> en de maandelijkse huurlasten op <strong>{{getLeaseCurrentMonthlyCharges lease}} €</strong>.</p>
        <p></p>
        <p>Met vriendelijke groeten,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
    `,
  },
  {
    id: '-122004',
    language: Language.DE,
    subject: 'Ihre Miete wird dieses Jahr nicht indexiert',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_RENT_INDEXATION_SKIPPED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Liebe/r {{listAllTenants lease}},</p>
        <p></p>
        <p>Ich freue mich, Ihnen mitteilen zu können, dass dieses Jahr keine Indexierung auf den Mietvertrag in <strong>{{getLeaseMainAddress lease}}</strong>, der am <strong>{{formatDate lease.startDate}}</strong> in Kraft getreten ist, angewendet wird.</p>
        <p></p>
        {{#if (hasMultipleUnits lease)}}
        <p>Liste der betroffenen Mieteinheiten: {{unitAddressList units}}.</p>
        <p></p>
        {{/if}}
        {{#if (hasComment leasePriceHistory)}}
        <p>Kommentar:</p>
        <i>{{leasePriceHistory.comment}}</i>
        <p></p>
        {{/if}}
        <p>Infolgedessen bleibt die monatliche Miete unverändert bei <strong>{{lease.totalRentalPrice}} €</strong> und die monatlichen Nebenkosten bei <strong>{{getLeaseCurrentMonthlyCharges lease}} €</strong>.</p>
        <p></p>
        <p>Mit freundlichen Grüßen,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
];
